<template>
    <div class="table">
        <table>
            <tr class="header text-left">
                <th
                    v-for="(header) in [...headers].sort((a,b) => a.index > b.index ? 1 : -1)"
                    :key="header.index"
                    class="pa-2"
                >
                    {{header.name}}
                </th>
            </tr>
            <tr
                class="data-row text-left"
                v-for="(element, index) in data"
                :key="index"
                :class="selected_index == index ? 'selected' : ''">
                <td 
                    v-for="(header, index2) in [...headers].sort((a,b) => a.index > b.index ? 1 : -1)"
                    :key="index2"
                    class="px-2"
                    @click="selectData(element, index)"
                >
                    {{ element[header.key] }}
                </td>
            </tr>
        </table>
      
    </div>
  </template>
  
  <script>
//   import { computed } from 'vue';
  
  export default {
    name: 'TableComponent',
    props: ['headers','data','startDataSelected'],
    emits: ['selected'],
    data() {
      return {
        selected_index: this.startDataSelected ? 0 : null
      }
    },
    computed: {
    },
    setup() {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        selectData(element, index) {
            this.$emit('selected', element);
            this.selected_index = index;
        }
    }
  }
  </script>
  
  <style lang="scss" scoped>
    .table {
        max-height: 300px;
        width: 100%;
        overflow: auto;
        overflow-x: hidden;
        position: relative;
        table {
            width: 100%;
            border-collapse: collapse;
            cursor: pointer;
            color: $ds-primary;
        }
        tr, td {
            height: 30px;
        }
        .data-row:not(.selected):hover {
            background: $ds-background-1
        }
        .header {
            position: sticky;
            top: 0px;
            background: white;
            box-shadow: 0px 0px 1px 1px $ds-background-1 inset;
        }
        .selected {
            background: $ds-primary;
            color: white;
        }
    }
  </style>